/* Enso — Pinterest Save buttons (23 Oct 2026; revised 24 Oct 2026)
   Deliberately NOT Pinterest's pinit.js: that script sets Pinterest advertising cookies
   (_pin_unauth etc.) on page load, which needs marketing consent in the UK, and Enso leaves
   marketing unset by default (see the consent comment in layout/theme.liquid). These are plain
   links to Pinterest's pin-create page, so nothing reaches Pinterest until a visitor clicks.
   1. Product pages, every device: "Save to Pinterest" on the gallery (.epc__stage) pins the
      slide currently shown.
   2. Desktop (hover + fine pointer): "Save" appears over any content image >= 200px on hover.
      It is placed inside the part of the image actually on screen: below the fixed header, the
      sticky product tab bar and anything else pinned to the viewport, and inside any clipping
      frame. It never shows while the pointer is over one of those pinned bars.
   Pin description = product / page title + "| Enso Lighting" — never alt text or body copy.
   Opt an image out with data-pin-nopin on the <img> or any ancestor. */
(function () {
  'use strict';
  if (window.__ensoPinSave) return;
  window.__ensoPinSave = true;

  var MIN_W = 200, MIN_H = 150, MIN_VISIBLE = 60;
  var SKIP = '[data-pin-nopin], header, footer, #header-group, nav, dialog, cart-drawer, .cart-drawer, ' +
             '.enso-search, .epc__stage, .epc__thumbs, .epc__tabs, .enso-pin, ' +
             '.needsclick, [class*="klaviyo"], [id*="klaviyo"], [class*="ask-enso"], [id*="ask-enso"]';
  var DROP = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid',
              'gbraid', 'wbraid', 'fbclid', 'msclkid', 'epik', '_pos', '_sid', '_ss', '_psq', '_v'];

  // z-index 19 on the hover pill: under the PDP tab bar (20), sticky buy bar (40), drawers (200+)
  // and header (10000), so even a stale pill can never paint over them.
  var css =
    '.enso-pin{display:inline-flex;align-items:center;gap:5px;background:#E60023;color:#fff;' +
    'font-family:inherit;font-size:12px;font-weight:600;line-height:1;letter-spacing:.01em;' +
    'padding:6px 10px;border-radius:999px;text-decoration:none;white-space:nowrap;' +
    'box-shadow:0 1px 3px rgba(0,0,0,.18);cursor:pointer;z-index:3}' +
    '.enso-pin:hover,.enso-pin:focus{background:#ad081b;color:#fff;text-decoration:none}' +
    '.enso-pin:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
    '.enso-pin svg{width:12px;height:12px;flex:none}' +
    '.enso-pin--hover{position:fixed;z-index:19}' +
    '.enso-pin--hover[hidden]{display:none}' +
    '.enso-pin--pdp{position:absolute;top:12px;right:12px}' +
    // phones: bottom of the photo sits under the buy card; zoom pill is at bottom 52px, thumb chips bottom-left
    '@media (max-width:749px){.enso-pin--pdp{top:auto;bottom:90px;right:12px;padding:6px 9px;font-size:11px}' +
    '.enso-pin--pdp .enso-pin__long{display:none}}';

  // generic pin glyph (not Pinterest's logo)
  var PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 17v5"></path><path d="M9 3h6l-1 6 3 3v2H7v-2l3-3z"></path></svg>';

  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function cleanUrl(u) {
    try {
      var x = new URL(u, location.href);
      x.hash = '';
      DROP.forEach(function (k) { x.searchParams.delete(k); });
      return x.href;
    } catch (e) { return location.origin + location.pathname; }
  }

  function pageUrl() {
    var c = document.querySelector('link[rel="canonical"]');
    var base = cleanUrl(location.href);
    // keep ?variant= so the pin opens on the finish that was pinned
    if (c && c.href && !/[?&]variant=/.test(base)) return cleanUrl(c.href);
    return base;
  }

  // full product title from the Product JSON-LD (the PDP h1 is only the short name, e.g. "Zola")
  function ldProductName() {
    var n = '';
    Array.prototype.some.call(document.querySelectorAll('script[type="application/ld+json"]'), function (s) {
      try {
        var j = JSON.parse(s.textContent);
        var list = Array.isArray(j) ? j : (j['@graph'] || [j]);
        return list.some(function (o) {
          if (o && o['@type'] === 'Product' && o.name) { n = String(o.name); return true; }
          return false;
        });
      } catch (e) { return false; }
    });
    return n;
  }

  function pageTitle() {
    var t = ldProductName() || text(document.querySelector('#epc h1, main h1'));
    if (!t) t = document.title.replace(/\s+[–|-]\s+Enso Lighting\s*$/i, '').trim();
    return t;
  }

  function describe(title) {
    title = (title || '').replace(/\s*\|\s*UK\s*$/i, '').slice(0, 300);
    return title ? title + ' | Enso Lighting' : 'Enso Lighting';
  }

  function bigSrc(img) {
    var s = img.currentSrc || img.getAttribute('src') || '';
    if (!s || s.indexOf('data:') === 0) {
      var set = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      s = set.split(',')[0].trim().split(/\s+/)[0] || '';
    }
    if (!s || s.indexOf('data:') === 0) return '';
    try {
      var u = new URL(s, location.href);
      if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(u.href)) {
        u.searchParams.delete('height');
        u.searchParams.delete('crop');
        u.searchParams.set('width', '1200');
      }
      return u.href;
    } catch (e) { return s; }
  }

  function pinHref(media, url, desc) {
    return 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) +
           '&media=' + encodeURIComponent(media) + '&description=' + encodeURIComponent(desc);
  }

  function makeButton(cls, label, aria) {
    var a = document.createElement('a');
    a.className = 'enso-pin ' + cls;
    a.target = '_blank';
    a.rel = 'noopener';
    a.href = 'https://www.pinterest.com/pin/create/button/';
    a.setAttribute('aria-label', aria);
    a.setAttribute('data-pin-nopin', '');
    a.innerHTML = PIN + '<span>' + label + '</span>';  // label may carry markup (static strings only)
    return a;
  }

  // 1. product gallery
  function setupGallery() {
    var stage = document.querySelector('#epc .epc__stage');
    var track = document.getElementById('epcTrack');
    if (!stage || !track || stage.querySelector('.enso-pin--pdp')) return;
    var btn = makeButton('enso-pin--pdp', 'Save<span class="enso-pin__long"> to Pinterest</span>', 'Save this photo to Pinterest');
    function refresh() {
      var slides = track.querySelectorAll('.epc__slide');
      if (!slides.length) return;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      i = Math.min(Math.max(i, 0), slides.length - 1);
      var img = slides[i].querySelector('img');
      var media = img && bigSrc(img);
      if (media) btn.href = pinHref(media, pageUrl(), describe(pageTitle()));
    }
    // href is rebuilt at click time; the browser follows the updated href
    btn.addEventListener('click', refresh);
    btn.addEventListener('mouseenter', refresh);
    btn.addEventListener('focus', refresh);
    refresh();
    stage.appendChild(btn);
  }

  // 2. desktop hover button
  function skipped(img) {
    // Klaviyo leaves "klaviyo-prevent-body-scrolling" on <body> after its popup closes, which
    // matched [class*="klaviyo"] and switched every hover button off — so ignore body/html.
    var m = img.closest(SKIP);
    return !!m && m !== document.body && m !== document.documentElement;
  }

  function eligible(img) {
    if (!img.isConnected || skipped(img)) return false;
    var src = img.currentSrc || img.src || '';
    if (!src || /\.svg(\?|$)/i.test(src)) return false;
    var r = img.getBoundingClientRect();
    return r.width >= MIN_W && r.height >= MIN_H;
  }

  // nearest ancestor-or-self pinned to the viewport (fixed or sticky), else null
  function pinnedOf(el) {
    for (var n = el; n && n.nodeType === 1 && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var p = getComputedStyle(n).position;
      if (p === 'fixed' || p === 'sticky') return n;
    }
    return null;
  }

  // a pinned bar / drawer / popup (not the image's own sticky frame) sitting over this point
  function coverOf(el, img) {
    var p = el && pinnedOf(el);
    return p && !p.contains(img) ? p : null;
  }

  // the part of the image actually on screen: clipped by overflow frames and the viewport
  function visibleRect(img) {
    var r = img.getBoundingClientRect();
    var t = r.top, l = r.left, b = r.bottom, rt = r.right;
    for (var n = img.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible' || /paint|strict|content/.test(cs.contain || '')) {
        var c = n.getBoundingClientRect();
        t = Math.max(t, c.top); l = Math.max(l, c.left);
        b = Math.min(b, c.bottom); rt = Math.min(rt, c.right);
      }
      if (cs.position === 'fixed') break;
    }
    return { top: Math.max(t, 0), left: Math.max(l, 0),
             bottom: Math.min(b, window.innerHeight), right: Math.min(rt, window.innerWidth) };
  }

  function cardInfo(img) {
    var a = img.closest('a[href]');
    if (!a || a.origin !== location.origin || !/\/products\//.test(a.pathname)) return null;
    var card = a.closest('product-card, .product-card, li, article') || a;
    var t = text(card.querySelector('.product-card__title, [class*="card__title"], [class*="product-title"], h2, h3'));
    return { url: cleanUrl(a.href), title: t || a.getAttribute('aria-label') || img.alt || '' };
  }

  function imgAt(x, y, stack) {
    // topmost visible <img> (product cards stack a hover image over the main one)
    for (var i = 0; i < stack.length && i < 8; i++) {
      if (stack[i].tagName === 'IMG' && parseFloat(getComputedStyle(stack[i]).opacity) > 0.1) return stack[i];
    }
    // images under an overlay link or with pointer-events:none
    for (var j = 0; j < stack.length && j < 4; j++) {
      var el = stack[j];
      if (el === document.body || el === document.documentElement || el.tagName === 'MAIN') break;
      var imgs = el.querySelectorAll ? el.querySelectorAll('img') : [];
      for (var k = 0; k < imgs.length && k < 6; k++) {
        var r = imgs[k].getBoundingClientRect();
        if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return imgs[k];
      }
    }
    return null;
  }

  function setupHover() {
    if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (!document.elementsFromPoint || !document.elementFromPoint) return;
    var btn = makeButton('enso-pin--hover', 'Save', 'Save this image to Pinterest');
    btn.hidden = true;
    document.body.appendChild(btn);
    var current = null, raf = 0, lx = 0, ly = 0;

    function hide() { btn.hidden = true; current = null; }

    // first y (from the visible top down) not covered by a pinned bar, checked across the pill's width
    function clearTop(v, img) {
      var xs = [Math.min(v.left + 12, v.right - 1), Math.min(v.left + 70, v.right - 1)];
      var y = v.top + 1;
      for (var guard = 0; guard < 8 && y < v.bottom; guard++) {
        var cover = null;
        for (var i = 0; i < xs.length && !cover; i++) cover = coverOf(document.elementFromPoint(xs[i], y), img);
        if (!cover) return y - 1;
        y = Math.max(y + 1, Math.ceil(cover.getBoundingClientRect().bottom) + 1);
      }
      return y < v.bottom ? y - 1 : v.bottom;
    }

    function show(img) {
      btn.hidden = true;  // keep the old pill out of the hit-test below
      var v = visibleRect(img);
      var top = clearTop(v, img);
      if (v.bottom - top < MIN_VISIBLE || v.right - v.left < 120) { hide(); return; }
      var info = cardInfo(img);
      var url = info ? info.url : pageUrl();
      var title = info && info.title ? info.title : pageTitle();
      var media = bigSrc(img);
      if (!media) { hide(); return; }
      btn.href = pinHref(media, url, describe(title));
      btn.style.top = Math.round(top + 10) + 'px';
      btn.style.left = Math.round(v.left + 10) + 'px';
      btn.hidden = false;
      current = img;
    }
    function check() {
      raf = 0;
      var stack = document.elementsFromPoint(lx, ly);
      if (!stack.length) { hide(); return; }
      if (stack[0] === btn || btn.contains(stack[0])) return;
      var img = imgAt(lx, ly, stack);
      if (!img || !eligible(img)) { hide(); return; }
      // pointer is over the header, tab bar, buy bar, a drawer or popup that sits over the image
      if (coverOf(stack[0], img)) { hide(); return; }
      if (img !== current) show(img);
    }
    document.addEventListener('mousemove', function (e) {
      lx = e.clientX; ly = e.clientY;
      if (!raf) raf = requestAnimationFrame(check);
    }, { passive: true });
    window.addEventListener('scroll', hide, { passive: true });
    window.addEventListener('resize', hide, { passive: true });
    document.addEventListener('mouseleave', hide);
  }

  function init() {
    var st = document.createElement('style');
    st.id = 'enso-pin-css';
    st.textContent = css;
    document.head.appendChild(st);
    setupGallery();
    setupHover();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
